import { render, staticRenderFns } from "./icon1.vue?vue&type=template&id=5e44bafa&scoped=true&"
import script from "./icon1.vue?vue&type=script&lang=js&"
export * from "./icon1.vue?vue&type=script&lang=js&"
import style0 from "./icon1.vue?vue&type=style&index=0&id=5e44bafa&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e44bafa",
  null
  
)

export default component.exports